import React from 'react';

const IconToggle = ({ onToggleClick, isEnable, disabled = false }) => {
  const handleToggle = () => {
    if (disabled) return;
    onToggleClick(!isEnable);
  };

  return (
    <em
      onClick={handleToggle}
      className={`icon ni ${isEnable ? 'ni-toggle-on' : 'ni-toggle-off'}`}
      style={{
        cursor: disabled ? 'not-allowed' : 'pointer',
        color: '#007bff',
        fontSize: '28px',
        opacity: disabled ? 0.5 : 1,
      }}
      aria-label="Toggle"
      aria-pressed={!!isEnable}
    ></em>
  );
};

export default IconToggle;
